/* eslint-disable global-require */
export default {
  'pt-BR': require('./pt-BR').default,
};
